import { useState, useEffect } from 'react';

const CANVAS_PADDING = 16;

/**
 * Hook to manage canvas dimensions for the WordCloud component
 *
 * @param {Object} containerRef - Reference to the container element
 * @param {Object} canvasRef - Reference to the canvas element
 * @param {number} containerHeight - Responsive container height
 * @param {number} wordsCount - Number of words in the cloud
 *
 * @returns {Object} Canvas dimensions
 */
export const useCanvasDimensions = (containerRef, canvasRef, containerHeight, wordsCount) => {
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  const updateCanvasDimensions = () => {
    const container = containerRef.current;
    const canvas = canvasRef.current;

    if (container && canvas && wordsCount) {
      const newHeight = containerHeight - CANVAS_PADDING;
      const newWidth = container.clientWidth - CANVAS_PADDING;

      canvas.height = newHeight;
      canvas.width = newWidth;

      setDimensions({ width: newWidth, height: newHeight });
    }
  };

  useEffect(() => {
    updateCanvasDimensions();
    window.addEventListener('resize', updateCanvasDimensions);

    return () => {
      window.removeEventListener('resize', updateCanvasDimensions);
    };
  }, [updateCanvasDimensions]);

  return dimensions;
};
